import { ref, watchEffect } from "vue";
import type { Ref } from "vue";

export interface UseFieldsetTouchTrackerOptions {
  /**
   * Function that returns whether the fieldset is valid.
   */
  isValid: () => boolean;
}

export interface UseFieldsetTouchTrackerApi {
  touched: Ref<boolean>;
  onFocusout: (event: FocusEvent) => void;
  reset: () => void;
}

export function useFieldsetTouchTracker(
  fieldsetRef: Ref<HTMLFieldSetElement | null>,
  options: UseFieldsetTouchTrackerOptions,
): UseFieldsetTouchTrackerApi {
  const touched = ref(false);

  // Keep aria-invalid synchronized with the composed validator function.
  watchEffect(() => {
    fieldsetRef.value?.setAttribute("aria-invalid", String(!options.isValid()));
  });

  function onFocusout(event: FocusEvent) {
    const fieldset =
      fieldsetRef.value ?? (event.currentTarget as HTMLElement | null);
    const next = event.relatedTarget as Node | null;

    if (!fieldset || !fieldset.contains(next)) {
      touched.value = true;
    }
  }

  function reset() {
    touched.value = false;
  }

  return { touched, onFocusout, reset };
}
